import * as React from 'react';
import S from './style/styled';
export var SmallParagraph = function SmallParagraph(_ref) {
  var style = _ref.style,
      children = _ref.children,
      extraProps = _ref.extraProps,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'p' : _ref$tag;
  return React.createElement(S.SmallParagraph, Object.assign({
    tag: tag,
    as: tag,
    style: style,
    children: children
  }, extraProps), children);
};